<script>
  import { Router, Route } from 'svelte-navigator'
  import WorkoutPlanList from './workoutplans/WorkoutPlanList.svelte'
  import WorkoutPlanEdit from './workoutplans/WorkoutPlanEdit.svelte'
  import WorkoutPlanTrain from './workoutplans/WorkoutPlanTrain.svelte'
  import WorkoutPlanClone from './workoutplans/WorkoutPlanClone.svelte'
  import WorkoutPlanView from './workoutplans/WorkoutPlanView.svelte'
  import WorkoutPlanNew from './workoutplans/WorkoutPlanNew.svelte'
</script>

<Router primary={false}>
  <Route path="/">
    <WorkoutPlanList />
  </Route>
  <Route path="/edit/:id" let:params>
    <WorkoutPlanEdit id={params.id} />
  </Route>
  <Route path="/train/:id" let:params>
    <WorkoutPlanTrain id={params.id} />
  </Route>
  <Route path="/clone/:id" let:params>
    <WorkoutPlanClone id={params.id} />
  </Route>
  <Route path="/view/:id" let:params>
    <WorkoutPlanView id={params.id} />
  </Route>
  <Route path="/new">
    <WorkoutPlanNew />
  </Route>
</Router>
